"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useTraceUpdate(compName, props, call) {
    if (call === void 0) { call = false; }
    var prev = react_1.useRef(props);
    react_1.useEffect(function () {
        var changedProps = Object.entries(props).reduce(function (ps, _a) {
            var k = _a[0], v = _a[1];
            if (prev.current[k] !== v) {
                ps[k] = [prev.current[k], v];
            }
            return ps;
        }, {});
        if (Object.keys(changedProps).length > 0 && call) {
            console.log("{" + compName + "} changed props:", changedProps);
        }
        prev.current = props;
    });
}
exports.default = useTraceUpdate;
//# sourceMappingURL=useTraceUpdate.js.map